import api from '@/api';
import {
  FinancialConsultPayableBind,
  FinancialConsultReceivableBind,
  FinancialConsultPayableListRequest,
  FinancialConsultReceivableListRequest,
  FinancialConsultPayable,
  FinancialConsultReceivable,
} from './consultation.types';
import { PageResult } from '@/core/request/PageResult';

const path = '/financial/v1/Consultation';

export default {
  async payableList(params: FinancialConsultPayableListRequest) {
    const result = (await api.get(
      `${path}/payable/installment`,
      params,
    )) as unknown;
    return result as PageResult<FinancialConsultPayable>;
  },

  async receivableList(params: FinancialConsultReceivableListRequest) {
    const result = (await api.get(
      `${path}/receivable/installment`,
      params,
    )) as unknown;
    return result as PageResult<FinancialConsultReceivable>;
  },

  async payableBind(params: FinancialConsultPayableBind) {
    await api.patch(`${path}/payable/bind-with-installment`, params, null);
  },

  async receivableBind(params: FinancialConsultReceivableBind) {
    await api.patch(`${path}/receivable/bind-with-installment`, params, null);
  },
};
